var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"outer-board-container"}},[_c('div',{attrs:{"id":"main-board"}}),(_vm.hexagonBoard)?_c('Overlay',{attrs:{"board":_vm.hexagonBoard}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }